/**
 * Parses a JSON string, returning `null` if the input is missing (null/undefined/empty)
 * or is not valid JSON, instead of throwing.
 *
 * Prefer this over `JSON.parse(value ?? '')` (which throws on an empty string) when reading
 * values that may not exist yet - e.g. localStorage/sessionStorage entries that can be absent
 * or cleared while the app is still running.
 */
export function safeJsonParse<T = any>(value: string | null | undefined): T | null {
  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}
